import { Vue, i18n } from "../components/vue.js";

// import components
import Autocomplete from "../components/vue/Autocomplete/Autocomplete.vue";

window.$_autocomplete = new Vue({
    i18n,
    render: (h) => h(Autocomplete),
}).$mount("#autocomplete");
